<div class="container">
  <div class="content-div">
    <div class="not-found-content">
      <p class="error-code">404</p>
      <p class="error-title">Page Not Found</p>
      <p class="error-message">
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>
      <a routerLink="/" class="home-link">
        Go to Home
      </a>
    </div>
  </div>
</div>
